import React, { useEffect, useState } from 'react'
import SmoothScroll from './SmoothScroll';
import SideMenu from './SideMenu';
import MenuButton from './MenuButton';
function Header() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <>
            <SmoothScroll />
            {/* header area start */}
            <header className={`header-area ${isSticky ? 'header--sticky sticky' : 'header--sticky'}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="header-wrapper with-after">
                                <div className="wrapper-inner">
                                    <div className="logo-area">
                                        <a href="#" className="logo">
                                            <img
                                                src="assets/images/logo/logo.svg"
                                                aria-label="logo"
                                                alt="logo_area"
                                            />
                                        </a>
                                    </div>
                                    <div className="nav-area">
                                        <ul className="">
                                            <li className="main-nav">
                                                <a className="main-menu" href="#home">
                                                    Home
                                                </a>
                                            </li>
                                            <li className="main-nav">
                                                <a className="main-menu" href="#about">
                                                    About Us
                                                </a>
                                            </li>
                                            <li className="main-nav">
                                                <a className="main-menu" href="#tokenomics">
                                                    Tokenomics
                                                </a>
                                            </li>
                                            <li className="main-nav">
                                                <a className="main-menu" href="#roadmap">
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li className="main-nav">
                                                <a className="main-menu" href="#faq">
                                                    FAQ
                                                </a>
                                            </li>
                                            <li className="main-nav">
                                                <a className="main-menu" href="#contact">
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="right-side">
                                        <div className="button with-after2">
                                            <a href="#contact" className="rts-btn btn-primary btn-header">
                                                Get Started
                                            </a>
                                        </div>
                                        <MenuButton toggleSidebar={toggleSidebar} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/* header area end */}
            <SideMenu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </>

    )
}

export default Header